export enum FiatWithdrawStatus {
  CREATED = 'CREATED',
  QUEUED = 'QUEUED',
  DONE = 'DONE',
  FAILED = 'FAILED'
}

export enum FiatWithdrawFailedReason {
  NOT_ENOUGH_BALANCE = 'NOT_ENOUGH_BALANCE',
  BALANCE_NOT_FOUND = 'BALANCE_NOT_FOUND',
  GATEWAY_ERROR = 'GATEWAY_ERROR',
  LIMITS_EXCEEDED = 'LIMITS_EXCEEDED',
  WITHDRAW_FEE_LESS_THAN_ESTIMATED = 'WITHDRAW_FEE_LESS_THAN_ESTIMATED'
}
